<template>
  <div class="ion-page">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title>Bewerk</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content fullscreen>
      <ion-grid>
        <ion-row>
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-card :color="color">
              <img :src="image" class="preview-image" />
              <ion-card-header>
                <ion-card-title id="title">{{ title }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row justify-content-center>
          <ion-button size="medium" @click="uploadPhoto()">Verander Foto</ion-button>
          <ion-button color="light" size="medium" @click="playSound()">Luister</ion-button>
        </ion-row>

        <!-- Type -->
        <ion-row>
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-item>
              <ion-label>
                Dit is een...
                <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-select interface="popover" @ionChange="handleType($event)" :value="type">
                <ion-select-option value="group">Groep</ion-select-option>
                <ion-select-option value="item">Los Item</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <!-- Group -->
        <ion-row>
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-item v-if="groups.length > 0">
              <ion-label>
                Onderdeel van Groep...
                <ion-text color="danger" v-if="this.type === 'item'">*</ion-text>
              </ion-label>
              <ion-select interface="popover" @ionChange="handleGroup($event)" :value="group">
                <ion-select-option
                  :value="group.id"
                  v-for="group in groups"
                  :key="group.id"
                >{{ group.title }}</ion-select-option>
              </ion-select>
            </ion-item>

            <ion-text
              color="danger"
              v-if="item.type === 'group' || item.type === 'groep'"
              style="margin-bottom: 2rem"
            >
              <p>
                Als je een groep veranderd in een los item, dan zal je alle items van deze groep
                kwijt raken.
              </p>
            </ion-text>

            <ion-text color="danger" v-if="!groups" style="margin-bottom: 2rem">
              <p>
                Je hebt nog geen groep gemaakt. Maak eerst een groep aan voordat je items kunt
                maken. Een item moet altijd onderdeel zijn van een groep.
              </p>
            </ion-text>
          </ion-col>
        </ion-row>

        <!-- Title -->
        <ion-row>
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-item>
              <ion-label position="floating">
                Vul een titel in
                <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input required type="text" @input="handleTitle($event)" :value="title"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <!--Spoken Text -->
        <ion-row v-if="this.type === 'item'">
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-item>
              <ion-label position="floating">
                Vul een gesproken tekst in
                <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input required type="text" @input="handleSpokenText($event)" :value="spokenText"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <!-- Color -->
        <ion-row>
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-item>
              <ion-label>Kleur</ion-label>
              <ion-select interface="popover" @ionChange="handleColor($event)" :value="color">
                <ion-select-option value>Geen</ion-select-option>
                <ion-select-option value="primary">Blauw</ion-select-option>
                <ion-select-option value="secondary">Turquoise</ion-select-option>
                <ion-select-option value="tertiary">Paars</ion-select-option>
                <ion-select-option value="success">Groen</ion-select-option>
                <ion-select-option value="warning">Geel</ion-select-option>
                <ion-select-option value="danger">Rood</ion-select-option>
                <ion-select-option value="light">Light Grijs</ion-select-option>
                <ion-select-option value="medium">Donker Grijs</ion-select-option>
                <ion-select-option value="dark">Zwart</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <!-- Save -->
        <ion-row class="ion-padding-top">
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button color="success" expand="block" @click="validateForm()">Opslaan</ion-button>
          </ion-col>
        </ion-row>

        <!-- Cancel -->
        <ion-row>
          <ion-col
            size="12"
            offset="0"
            size-sm="12"
            offset-sm="0"
            size-md="4"
            offset-md="4"
            size-lg="4"
            offset-lg="4"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button color="primary" expand="block" @click="back()">Cancel</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>

    <ion-fab
      horizontal="start"
      vertical="bottom"
      slot="fixed"
      @click="usePhoto"
      v-if="isEditingPhoto"
    >
      <ion-fab-button color="success">
        <ion-icon name="checkmark"></ion-icon>
      </ion-fab-button>
    </ion-fab>

    <input type="file" accept="image/*" class="upload-photo" @change="handleFile($event)" />
    <img :src="uploadedImage" id="crop" @click="crop($event)" />
  </div>
</template>
<style src="../components/cropperjs.css"></style>
<style scoped>
.upload-photo {
  display: none;
}

img {
  display: none;
  max-width: 100%; /* This rule is very important, please do not ignore this! */
}

.preview-image {
  display: block;
}
</style>
<script>
import Cropper from "cropperjs";
import { db, firebase, storage } from "@/firebase/firebase";

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
let cropper = "";

export default {
  name: "edit",
  components: {},
  data() {
    return {
      editingID: this.$route.params.id,
      item: "",
      title: "",
      spokenText: "",
      color: "",
      type: "",
      group: "",
      image: "https://ionicframework.com/docs/demos/api/card/madison.jpg",
      uploadedImage: "",
      croppedImage: "",
      isEditingPhoto: false
    };
  },
  watch: {},
  computed: {
    groups() {
      return this.$store.state.items.filter(item => {
        if (item.type === "group" || item.type === "groep") {
          return item;
        }
      });
    }
  },
  methods: {
    handleTitle(event) {
      this.title = event.target.value;
      if (event.target.value != "") {
        document.getElementById("title").innerHTML = this.title;
      } else {
        document.getElementById("title").innerHTML = "Voorbeeld";
      }
    },
    handleSpokenText(event) {
      this.spokenText = event.target.value;
    },
    handleColor(event) {
      this.color = event.target.value;
      // this.color = color;
      let card = document.querySelector("ion-card");
      card.setAttribute("card", this.color);
    },
    handleType(event) {
      this.type = event.target.value;
    },
    handleGroup(event) {
      this.group = event.target.value;
    },
    playSound() {
      let speak = this.spokenText;
      if (speak === "") {
        speak = "U heeft nog geen gesproken tekst ingevuld";
      }
      window.responsiveVoice.speak(speak, "Dutch Female");
    },
    uploadPhoto() {
      let addPhotoInput = document.getElementsByClassName("upload-photo")[0];
      addPhotoInput.click();
    },
    async handleFile(event) {
      console.log(event.target.files);
      const selectedFile = event.target.files[0];
      this.uploadedImage = await toBase64(selectedFile);
      setTimeout(() => {
        this.editPhoto();
      }, 100);
    },
    editPhoto() {
      let editPhoto = document.getElementById("crop");
      console.log(editPhoto);
      editPhoto.click();
    },
    crop(event) {
      this.isEditingPhoto = true;
      const image = document.getElementById("crop");
      // console.log(event);
      // console.log(event.target);
      cropper = new Cropper(image, {
        aspectRatio: 16 / 9,
        crop(event) {}
      });
    },
    usePhoto() {
      let vueElement = this;
      cropper
        .getCroppedCanvas({
          imageSmoothingEnabled: true,
          imageSmoothingQuality: "high"
        })
        .toBlob(blob => {
          vueElement.processfile(blob);
        });
    },
    processfile(blob) {
      // read the files
      let vueElement = this;
      var reader = new FileReader();
      reader.readAsArrayBuffer(blob);

      reader.onload = function(event) {
        // blob stuff
        let blob = new Blob([event.target.result]); // create blob...
        window.URL = window.URL || window.webkitURL;
        let blobURL = window.URL.createObjectURL(blob); // and get it's URL

        // helper Image object
        let image = new Image();
        image.src = blobURL;
        image.onload = function() {
          // have to wait till it's loaded
          let resized = vueElement.resizeMe(image); // resized image url
          vueElement.image = resized;
          vueElement.isEditingPhoto = false;
          cropper.destroy();
        };
      };
    },
    resizeMe(img) {
      var canvas = document.createElement("canvas");

      var width = img.width;
      var height = img.height;

      // calculate the width and height, constraining the proportions
      if (width > height) {
        if (width > 450) {
          //height *= max_width / width;
          height = Math.round((height *= 450 / width));
          width = 450;
        }
      } else {
        if (height > 300) {
          //width *= max_height / height;
          width = Math.round((width *= 300 / height));
          height = 300;
        }
      }

      // resize the canvas and draw the image data into it
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      return canvas.toDataURL("image/jpeg", 0.8); // get the data from canvas as 70% JPG (can be also PNG, etc.)

      // you can get BLOB too by using canvas.toBlob(blob => {});
    },
    validateForm() {
      if (this.type === "item") {
        if (
          this.validateType() &&
          this.validateTitle() &&
          this.validateSpokenText() &&
          this.validateImage()
        ) {
          console.log("All form fields approved");
          this.save();
        } else {
          console.log("There is an issue");
        }
      } else {
        if (
          this.validateType() &&
          this.validateTitle() &&
          this.validateImage()
        ) {
          console.log("All form fields approved");
          this.save();
        } else {
          console.log("There is an issue");
        }
      }
    },
    validateTitle() {
      if (this.title === "") {
        let error = "Je hebt geen titel ingevuld.";
        this.presentAlert(error);
        return false;
      } else {
        return true;
      }
    },
    validateType() {
      if (this.type === "") {
        let error =
          "Je hebt niet gezegd of het een groep of dat het een los item is.";
        this.presentAlert(error);
        return false;
      } else if (this.type === "item" && this.group === "") {
        let error = "Je hebt geen groep ingevuld.";
        this.presentAlert(error);
        return false;
      } else {
        return true;
      }
    },
    validateSpokenText() {
      if (this.spokenText === "") {
        let error = "Je hebt geen gesproken tekst ingevuld.";
        this.presentAlert(error);
        return false;
      } else {
        return true;
      }
    },
    validateImage() {
      if (this.uploadedImage === "") {
        let error = "Je hebt geen foto ingevuld.";
        this.presentAlert(error);
        return false;
      } else {
        return true;
      }
    },
    save() {
      let vueElement = this;
      db.collection("users")
        .doc(firebase.auth().currentUser.uid)
        .collection("items")
        .doc(this.$route.params.id)
        .update({
          title: this.title,
          spokenText: this.spokenText,
          color: this.color,
          type: this.type,
          group: this.group
        })
        .then(function() {
          if (vueElement.image === vueElement.item.image) {
            console.log("Document successfully updated! Same Image");
          } else {
            console.log("Document successfully updated!");
            let image = vueElement.image;
            console.log(image);
            let storageRef = storage.child(
              "users/" +
                firebase.auth().currentUser.uid +
                "/items/" +
                vueElement.$route.params.id
            );
            storageRef
              .putString(image, "data_url")
              .then(function(snapshot) {
                console.log("Uploaded a base64 string!");
                console.log("Image successfully updated!");
                console.log(snapshot);
                snapshot.ref.getDownloadURL().then(function(downloadURL) {
                  console.log("File available at", downloadURL);
                  firebase
                    .firestore()
                    .collection("users")
                    .doc(firebase.auth().currentUser.uid)
                    .collection("items")
                    .doc(vueElement.editingID)
                    .update({
                      image: downloadURL
                    });
                  console.log(vueElement.editingID);
                  vueElement.$router.push("/edit/");
                });
              })
              .catch(function(error) {
                // The document probably doesn't exist.
                console.error("Error updating document: ", error);
              });
            console.log(
              "Document written with ID: ",
              vueElement.$route.params.id
            );
          }
          // vueElement.$router.push("/edit/");
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    },
    presentAlert(error) {
      return this.$ionic.alertController
        .create({
          header: "Oops..",
          message: error,
          buttons: ["OK"]
        })
        .then(a => a.present());
    },
    back() {
      this.$router.push("/edit/");
    }
  },
  created() {
    this.$store.state.items.filter(item => {
      if (item.id === this.$route.params.id) {
        this.item = item;
        this.title = item.title;
        this.color = item.color;
        this.type = item.type;
        this.group = item.group;
        this.spokenText = item.spokenText;
        this.image = item.image;
        this.croppedImage = item.image;
        this.uploadedImage = item.image;
        console.log(item.title);
      }
    });
  }
};
</script>
